import React from 'react';
import {
	Dialog,
	AppBar,
	Toolbar,
	Grid,
	Typography,
	Button,
	TextField,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Slide
} from '@mui/material';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export const EditarDocumento = ({ open, onClose }) => {
	return (
		<Dialog
			fullScreen
			open={open}
			onClose={onClose}
			TransitionComponent={Transition}
		>
			<Grid container direction="column" sx={{ height: '100vh' }}>

				{/* HEADER FIJO */}
				<AppBar
					position="static"
					sx={{ bgcolor: '#0f2a2a' }}
				>
					<Toolbar sx={{ justifyContent: 'space-between' }}>
						<Button
							variant="contained"
							color="error"
							onClick={onClose}
						>
							Cancelar
						</Button>

						<Typography fontWeight={600}>
							Editar documento
						</Typography>

						<Button
							variant="contained"
							color="success"
						>
							Guardar
						</Button>
					</Toolbar>
				</AppBar>

				{/* CONTENIDO */}
				<Grid
					container
					direction="column"
					sx={{
						p: 3,
						overflowY: 'auto',
						flex: 1
					}}
				>

					{/* PESTAÑA INFO */}
					<Grid
						container
						alignItems="center"
						spacing={1}
						sx={{ mb: 2 }}
					>
						<InfoOutlinedIcon fontSize="small" />
						<Typography fontWeight={600}>
							Información
						</Typography>
					</Grid>

					<Typography fontWeight={600} sx={{ mb: 2 }}>
						Información obligatoria
					</Typography>

					{/* FORMULARIO */}
					<Grid container spacing={2}>

						<Grid item size={{ xs: 12, md: 4 }}>
							<TextField
								label="Nombre"
								fullWidth
								required
								defaultValue="xxx - EJEMPLO-ENTREGA-DE"
							/>
						</Grid>

						<Grid item size={{ xs: 12, md: 4 }}>
							<FormControl fullWidth>
								<InputLabel>Empresas / Clientes</InputLabel>
								<Select defaultValue="San Alfonso">
									<MenuItem value="San Alfonso">San Alfonso</MenuItem>
								</Select>
							</FormControl>
						</Grid>

						<Grid item size={{ xs: 12, md: 4 }}>
							<FormControl fullWidth>
								<InputLabel>Tipo</InputLabel>
								<Select defaultValue="Opcional">
									<MenuItem value="Opcional">Opcional</MenuItem>
									<MenuItem value="Obligatorio">Obligatorio</MenuItem>
								</Select>
							</FormControl>
						</Grid>

						<Grid item size={{ xs: 12, md: 4 }}>
							<FormControl fullWidth>
								<InputLabel>Tipo de firma</InputLabel>
								<Select defaultValue="Firma electrónica">
									<MenuItem value="Firma electrónica">
										Firma electrónica
									</MenuItem>
								</Select>
							</FormControl>
						</Grid>

						<Grid item size={{ xs: 12, md: 4 }}>
							<FormControl fullWidth>
								<InputLabel>Privacidad</InputLabel>
								<Select defaultValue="Público">
									<MenuItem value="Público">Público</MenuItem>
									<MenuItem value="Privado">Privado</MenuItem>
								</Select>
							</FormControl>
						</Grid>

						<Grid item size={{ xs: 12, md: 4 }}>
							<FormControl fullWidth>
								<InputLabel>Entidades</InputLabel>
								<Select defaultValue="Personas">
									<MenuItem value="Personas">Personas</MenuItem>
									<MenuItem value="Carpetas">Carpetas</MenuItem>
								</Select>
							</FormControl>
						</Grid>

						<Grid item size={{ xs: 12, md: 4 }}>
							<FormControl fullWidth>
								<InputLabel>Añadir por defecto</InputLabel>
								<Select defaultValue="Sí">
									<MenuItem value="Sí">Sí</MenuItem>
									<MenuItem value="No">No</MenuItem>
								</Select>
							</FormControl>
						</Grid>

						<Grid item size={{ xs: 12, md: 4 }}>
							<FormControl fullWidth>
								<InputLabel>Carpeta por defecto</InputLabel>
								<Select defaultValue="">
									<MenuItem value="">—</MenuItem>
								</Select>
							</FormControl>
						</Grid>

					</Grid>
				</Grid>
			</Grid>
		</Dialog>
	);
};
